module.exports = __webpack_public_path__ + "img/guoz.4dea1a64.svg";